import React from "react"
import { Col, Container, Row } from "react-bootstrap" // Gatsby nutzt oft react-bootstrap
import westfaliaImg from "../../assets/images/about/Westfalia_Logo_color.png"
import wortmannImg from "../../assets/images/customers/wortmann.png"
import { Link } from "gatsby"

const PartnerNetwork = () => {
  return (
    <section className="py-5" style={{ backgroundColor: "#f8f9fa", marginTop: "4em" }}>
      <Container>
        <Row className="mb-5 text-center">
          <Col>
            <h2 className="fw-bold">Starke Wurzeln, gemeinsame Vision</h2>
            <p className="text-muted" style={{ fontSize: "1.1rem" }}>
              Als Teil eines etablierten Netzwerks verbinden wir Agilität mit globaler Stärke.
            </p>
          </Col>
        </Row>

        <Row className="g-4 my-4">
          {/* Westfalia Card */}
          <Col lg={6} className="mb-4 mb-lg-0">
            <div
              className="h-100 p-4 border-0 rounded shadow-sm bg-white"
              style={{
                borderLeft: "5px solid #4e3601" // Dein Akzent-Braun
              }}
            >
              <div className="mb-4" style={{ height: "45px" }}>
                <img src={westfaliaImg} alt="Westfalia" style={{ maxHeight: "100%", width: "165px" }} />
              </div>
              <h2 className="h4 mb-3">
                Brückenschlag zur Automatisierung
              </h2>
              <p className="text-dark" style={{ lineHeight: "1.6", fontSize: "16px" }}>
                Seit 2019 sind wir hundertprozentige Tochter der Westfalia-Gruppe. Die <Link
                to={"https://www.westfaliaeurope.com/"}>Westfalia Technologies GmbH & Co.
                KG</Link> mit Sitz in Borgholzhausen ist Anbieter schlüsselfertiger automatischer Lagersysteme.
                In gemeinsamen Teams entwickeln wir das moderne Warehouse Management weiter, mit Schnittstellen zwischen
                Westfalias leistungsstarkem Warehouse Execution System <Link
                to={"https://www.westfaliaeurope.com/software-it/savannanetr.html"}>Savanna.NET<sup>®</sup></Link> für
                Steuerung
                und Verwaltung
                automatisierter Lagersysteme und unserem Warehouse Management System <Link
                to={"https://logentis.de/lagerverwaltung/"}>NETSTORSYS</Link>, das auf
                Webtechnologien,
                fortschrittliche Lager- und Picking-Strategien setzt. Gemeinsam bilden wir die gesamte Bandbreite der
                integrierten manuellen und automatisierten Lagerung ab.
              </p>
            </div>
          </Col>

          {/* Wortmann Card - Jetzt im gleichen Look */}
          <Col lg={6}>
            <div
              className="h-100 p-4 border-0 rounded shadow-sm bg-white"
              style={{
                borderLeft: "5px solid #4e3601" // Gleiche Akzent-Linie
              }}
            >
              <div className="mb-4" style={{ height: "45px" }}>
                {/* Hier das Original-Logo verwenden, kein Invert nötig auf Weiß */}
                <img src={wortmannImg} alt="WORTMANN AG" style={{ maxHeight: "100%" }} />
              </div>
              <h2 className="h4 mb-3">
                Eine starke Familie
              </h2>
              <p className="text-dark" style={{ lineHeight: "1.6", fontSize: "16px" }}>
                Mit Westfalia sind wir Teil einer starken Unternehmensfamilie für leistungsstarke Gesamtsysteme – der
                WORTMANN Gruppe mit einem Jahresumsatz 2025 von mehr als 2,4 Milliarden Euro und mehr als 30 Firmen im
                Verbund. Das erweitert unsere Möglichkeiten um Technologien der <Link
                to={"https://www.wortmann.de/de-de/content/unternehmen-kurzprofil/kurzprofil.aspx"}>WORTMANN AG</Link>,
                eines der erfolgreichsten
                unabhängigen deutschen IT-Unternehmen.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default PartnerNetwork
